export default __webpack_public_path__ + "static/media/Path 734.0ec47308.svg";